import { render } from "./DocumentiView.vue?vue&type=template&id=67748512&scoped=true"
import script from "./DocumentiView.vue?vue&type=script&lang=js"
export * from "./DocumentiView.vue?vue&type=script&lang=js"

import "./DocumentiView.vue?vue&type=style&index=0&id=67748512&scoped=true&lang=css"

import exportComponent from "C:\\Users\\diego\\source\\repos\\PoligeoDocumenti\\PoligeoDocumenti\\poligeo-documenti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67748512"]])

export default __exports__